var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWifi = function SvgWifi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 21.2 16.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M6.314 11.054c2.367-2.51 6.205-2.51 8.572 0M3.457 8.024c3.945-4.184 10.341-4.184 14.286 0M.6 4.994c5.523-5.858 14.477-5.858 20 0m-9 9.606a1 1 0 1 1-2 0m2 0a1 1 0 1 0-2 0m2 0h-2"
  })));
};
export default SvgWifi;